module.exports = __webpack_public_path__ + "static/media/ApplicationTracker.50949840.png";